import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  IDocument,
  IDocumentsPage,
  IDocumentState,
  IDocumentUpdate,
} from "../@types/document";

const initialState: IDocumentState = {
  documents: [],
  document: null,
  limit: 20,
  offset: 0,
  total: 0,
  shared_documents: [],
  loading: false,
};

export const document = createSlice({
  name: "document",
  initialState,
  reducers: {
    setDocuments: (state, action: PayloadAction<IDocumentsPage>) => {
      state.documents = action.payload.data;
      state.limit = action.payload.limit;
      state.offset = action.payload.offset;
      state.total = action.payload.total;
    },
    setSharedDocuments: (state, action) => {
      state.shared_documents = action.payload.data.data;
    },
    createDocument: (state, action) => {
      state.documents = [...state.documents, action.payload];
    },
    setDocument: (state, action: PayloadAction<IDocument | null>) => {
      state.document = action.payload;
    },
    updateDocument: (state, action: PayloadAction<IDocumentUpdate>) => {
      state.documents = state.documents.map((item) =>
        String(item.id) === String(action.payload.id)
          ? { ...item, ...action.payload }
          : item,
      );
      if (
        state.document &&
        String(state.document.id) === String(action.payload.id)
      ) {
        state.document = { ...state.document, ...action.payload };
      }
    },
    removeDocument: (state, action: PayloadAction<IDocument["id"]>) => {
      state.documents = state.documents.filter(
        (item) => String(item.id) !== String(action.payload),
      );
      if (
        state.document &&
        String(state.document.id) === String(action.payload)
      ) {
        state.document = null;
      }
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const {
  setDocuments,
  setSharedDocuments,
  setDocument,
  updateDocument,
  removeDocument,
  setLoading,
} = document.actions;

export default document.reducer;
